import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    onClickRemoveRule,
    onChangeCustomFilters,
    openSaveModal,
    onClickClear,
    onChangeField,
    getCampaignsFiltersInterface,
    onChangeOperator,
    onChangeValue,
    onClickApply,
    closeSaveModal,
    saveFilter,
    CampaignsFiltersInterface,
} from './interface.state';

type Actions = {
    onClickRemoveRule: (rule) => void;
    onChangeCustomFilters: (newValue) => void;
    openSaveModal: () => void;
    onClickClear: () => void;
    onChangeField: (newField) => void;
    onChangeOperator: (newOperator) => void;
    onChangeValue: (newValue) => void;
    onClickApply: (rule) => void;
    closeSaveModal: () => void;
    saveFilter: (newFilter) => void;
}

type UseCampaignFilterInterface = Actions & CampaignsFiltersInterface

export const useCampaignFilterInterface = () : UseCampaignFilterInterface => {
    const dispatch = useDispatch();
    const filtersInterface = useSelector(getCampaignsFiltersInterface);

    const handleOnClickRemoveRule = useCallback((rule) => {
        dispatch(onClickRemoveRule(rule));
    }, [dispatch]);

    const handleOnChangeCustomFilters = useCallback((newValue) => {
        dispatch(onChangeCustomFilters(newValue));
    }, [dispatch]);

    const handleOpenSaveModal = useCallback(() => {
        dispatch(openSaveModal());
    }, [dispatch]);

    const handleOnClickClear = useCallback(() => {
        dispatch(onClickClear());
    }, [dispatch]);

    const handleOnChangeField = useCallback((newField) => {
        dispatch(onChangeField(newField));
    }, [dispatch]);

    const handleOnChangeOperator = useCallback((newOperator) => {
        dispatch(onChangeOperator(newOperator));
    }, [dispatch]);

    const handleOnChangeValue = useCallback((newValue) => {
        dispatch(onChangeValue(newValue));
    }, [dispatch]);

    const handleOnClickApply = useCallback((rule) => {
        dispatch(onClickApply(rule));
    }, [dispatch]);

    const handleCloseSaveModal = useCallback(() => {
        dispatch(closeSaveModal());
    }, [dispatch]);

    const handleSaveFilter = useCallback(({ filterName }) => {
        dispatch(saveFilter({ filterName }));
    }, [dispatch]);

    return {
        ...filtersInterface,
        onClickRemoveRule: handleOnClickRemoveRule,
        onChangeCustomFilters: handleOnChangeCustomFilters,
        openSaveModal: handleOpenSaveModal,
        onClickClear: handleOnClickClear,
        onChangeField: handleOnChangeField,
        onChangeOperator: handleOnChangeOperator,
        onChangeValue: handleOnChangeValue,
        onClickApply: handleOnClickApply,
        closeSaveModal: handleCloseSaveModal,
        saveFilter: handleSaveFilter,
    };
};
